var bumpDataSelectTarget = 'bump-select-target';
var bumpTimeSelect = 'select[data-' + bumpDataSelectTarget + ']';

function bindSelectChangeHandler() {
  $(document).on('change', bumpTimeSelect, function (e) {
    showOnlySelected(e.target);
  });
}

function showOnlySelected(select) {
  var $select = $(select);

  var viewTarget = $($select.data(bumpDataSelectTarget));
  viewTarget.hide();

  var selected = $select.val();
  viewTarget.filter('[data-time-period=' + selected + ']').show();
}

function init() {
  bindSelectChangeHandler();
  $(bumpTimeSelect).each(function (index, el) {
    showOnlySelected(el);
  });
}

module.exports = {
  init,
};



// WEBPACK FOOTER //
// ./javascripts/components/legacy/bump/shop_stats.js